import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import CartDrawer from "@/components/cart/CartDrawer";
import CartReminderBanner from "@/components/cart/CartReminderBanner";
import Analytics from "@/components/Analytics";
import Landing from "@/pages/Landing";
import EventDetailPage from "@/pages/EventDetailPage";
import ProductPage from "@/pages/ProductPage";
import CheckoutPage from "@/pages/CheckoutPage";
import OrderConfirmation from "@/pages/OrderConfirmation";
import PageView from "@/pages/PageView";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import CheckInPage from "@/pages/CheckInPage";
import TicketPage from "@/pages/TicketPage";

function DonateRedirect() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/", { replace: true });
    const t = setTimeout(() => {
      document.querySelector('[data-testid="donate-section"]')?.scrollIntoView({ behavior: "smooth" });
    }, 600);
    return () => clearTimeout(t);
  }, [navigate]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/events/:eventId" element={<EventDetailPage />} />
            <Route path="/shop/:productId" element={<ProductPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/order-confirmation/:orderId" element={<OrderConfirmation />} />
            <Route path="/p/:slug" element={<PageView />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/checkin" element={<CheckInPage />} />
            <Route path="/ticket/:code" element={<TicketPage />} />
            <Route path="/donate" element={<DonateRedirect />} />
          </Routes>
          <CartDrawer />
          <CartReminderBanner />
          <Analytics />
        </BrowserRouter>
      </CartProvider>
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
